// removed by extract-text-webpack-plugin
module.exports = {"container":"app-pages-Outlets-__Outlet___3gN6K"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Outlets/Outlet.css
// module id = 2473
// module chunks = 0